import UserInfoService from 'src/utils/UserInfoService';
import PopupService from 'src/utils/PopupService';
import i18n from 'src/lang/i18n';
import { refreshToken } from 'src/api';
import axios from 'axios';
import { goBack } from 'src/utils';
const DEFAULT_BASE_URL = window?.config?.baseUrl; // 'https://mbal-api-test.azurewebsites.net';
const DEFAULT_TIMEOUT = 90000;
let refreshPromise: Promise<any>;

const getHeaders: any = () => {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${UserInfoService.getAccessToken()}`,
  };
};

const _doExpired = () => {
  UserInfoService.clearInfo();
  PopupService.instance.current.open({
    visible: true,
    title: i18n.t('notification'),
    content: i18n.t('session_expired_message'),
    okTitle: i18n.t('close'),
    showIcon: false,
    onOk: () => {
      PopupService.instance.current.close();
      goBack();
    },
  });
};

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log('Error interceptor', error?.code, error.toString());
    const config = error?.config;
    if (error?.toString()?.startsWith('Error: Network Error')) {
      // No internet
      PopupService.instance.current.open({
        showIcon: false,
        visible: true,
        title: i18n.t('notification'),
        content: i18n.t('no_internet'),
        okTitle: i18n.t('close'),
        onOk: () => {
          PopupService.instance.current.close();
        },
      });
    } else if (error?.code == 'ECONNABORTED') {
      // Timeout
      PopupService.instance.current.open({
        showIcon: false,
        visible: true,
        title: i18n.t('notification'),
        content: i18n.t('general_error'),
        okTitle: i18n.t('close'),
        onOk: () => {
          PopupService.instance.current.close();
        },
      });
    } else if (error?.response?.status >= 500) {
      // Internal server
      PopupService.instance.current.open({
        showIcon: false,
        visible: true,
        title: i18n.t('notification'),
        content: i18n.t('general_error'),
        okTitle: i18n.t('close'),
        onOk: () => {
          PopupService.instance.current.close();
        },
      });
    } else if (
      (error?.response?.status == 401 || error?.response?.status == 400) &&
      config?.url == '/authentication/refresh-token'
    ) {
      _doExpired();
    } else if (error?.response?.status == 401) {
      if (!refreshPromise) {
        refreshPromise = refreshToken(UserInfoService.getRefreshToken()).then(
          (refreshTokenRes) => {
            console.log('refreshTokenRes', refreshTokenRes);
            UserInfoService.setInfo(
              refreshTokenRes?.data?.access_token,
              refreshTokenRes?.data?.refresh_token
            );
            refreshPromise = null;
            return refreshTokenRes?.data?.access_token;
          }
        );
      }
      return refreshPromise
        .then((newAccessToken) => {
          console.log('newAccessToken', newAccessToken);
          config.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return axios(config);
        })
        .catch((refreshPromiseErr) => {
          console.log('refreshPromiseErr', refreshPromiseErr);
          _doExpired();
          return Promise.reject(error);
        });
    } else if (
      config?.url == '/authentication/mbapp/login' &&
      error?.response?.status == 400
    ) {
      _doExpired();
    }
    return Promise.reject(error);
  }
);
export interface RequestParams {
  url: string;
  baseURL?: string;
  params?: any;
  headers?: any;
  queryParams?: any;
}

export const get = async (requestParams: RequestParams) => {
  console.log('Request get', requestParams);
  const response = await axios.get(requestParams.url, {
    params: requestParams.params,
    baseURL: requestParams.baseURL || DEFAULT_BASE_URL,
    timeout: DEFAULT_TIMEOUT,
    headers: requestParams.headers || getHeaders(),
  });
  return response;
};

export const post = async (requestParams: RequestParams) => {
  console.log('Request post', requestParams);
  const response = await axios.post(requestParams.url, requestParams.params, {
    params: requestParams.queryParams,
    baseURL: requestParams.baseURL || DEFAULT_BASE_URL,
    timeout: DEFAULT_TIMEOUT,
    headers: requestParams.headers || getHeaders(),
  });
  return response;
};
